import { render, staticRenderFns } from "./TransferSyllablesPreview.vue?vue&type=template&id=d3a2ee42&lang=pug&"
import script from "./TransferSyllablesPreview.vue?vue&type=script&lang=js&"
export * from "./TransferSyllablesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports